import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../../hooks/snackBar';
import FormControl from '@material-ui/core/FormControl';
import PerfilSellerDadosFinanceiros from '../DadosFinanceiros';
import services from '../../../../services'
import {
    cadastrarRemuneracaoSeller,
    editarRemuneracao,
    obterIdRemuneracaoSeller,
    detalheRemuneracaoSeller,
    inativarRemuneracaoSeller
} from '../../../../services/http/SellerAdminstradorService/remuneracaoSellerService';

import CurrencyTextField from '@unicef/material-ui-currency-textfield';

import './styles.scss';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const PerfilSellerRemuneracaoGreener = () => {
    const history = useHistory();
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [idRemuneracaoSeller, setIdRemuneracaoSeller] = useState(false);
    const { idSeller } = services.storage.getUser();
    const { addSnackBar } = useSnackBar();
    const [remuneracao, setRemuneracao] = useState(
        {
            id: undefined,
            contratoEnviadoSeller: false,
            contratoAprovadoSeller: false,
            fee: null,
            setupIntegracao: null,
            comissao: null,
            dadosFinanceiros: [
                {
                    id: undefined,
                    dadosEmpresaSellerId: "",
                    banco: "",
                    agencia: "",
                    conta: "",
                    principal: false
                }
            ]
        });

    const adicionarConta = () => {
        remuneracao.dadosFinanceiros.push({
            dadosEmpresaSellerId: "",
            banco: "",
            agencia: "",
            conta: "",
            principal: false
        })

        setRemuneracao((prevent) => ({
            ...prevent,
            dadosFinanceiros: remuneracao.dadosFinanceiros
        }));
    }

    const changeRemueracaoObj = (value, propertie) => {
        setRemuneracao((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const obterDetalhesRemuneracaoSeller = (idRemuneracao) => {
        trackPromise(
            detalheRemuneracaoSeller(idRemuneracao, idSeller)
                .then(res => {
                    if (!res.fail) {
                        setRemuneracao(res.data);
                    } else {
                        addSnackBar({ message: 'Não foi possível recuperar remuneração seller', info: 'warning', open: true });
                        /* res.errors.forEach(element => {
                            addSnackBar({ message: element.menssagem, info: 'warning', open: true });  
                        }); */

                    }
                }).catch(error => {
                    console.log(error);
                    addSnackBar({ message: 'Erro ao recuperar remuneração seller', info: 'error', open: true });
                })
        )
    }


    const getIdRemuneracaoSeller = () => {
        //alert(idSeller);
        trackPromise(
            obterIdRemuneracaoSeller(idSeller)
                .then(res => {
                    //alert(res.fail);
                    if (!res.fail) {
                        //alert(res.data);
                        setIdRemuneracaoSeller(res.data);
                        obterDetalhesRemuneracaoSeller(res.data);
                    }
                }).catch(error => {
                    console.log(error);
                    addSnackBar({ message: 'Erro ao recuperar remuneração seller', info: 'error', open: true });
                })
        )
    }

    useEffect(() => {
        getIdRemuneracaoSeller();
    }, []);

    const validarForm = () => {
        var isInvalidForm = false;
        if (!remuneracao?.fee) isInvalidForm = true;
        if (!remuneracao?.setupIntegracao) isInvalidForm = true;
        if (!remuneracao?.comissao) isInvalidForm = true;
        if (remuneracao.dadosFinanceiros.length == 1) {
            if (remuneracao.dadosFinanceiros[0].conta === ""
                || remuneracao.dadosFinanceiros[0].agencia === ""
                || remuneracao.dadosFinanceiros[0].banco === ""
                || remuneracao.dadosFinanceiros[0].principal === false) {
                addSnackBar({ message: 'Informe ao menos uma conta principal', info: 'warning', open: true });
                isInvalidForm = true;
            }
        }
        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const contaBancaria = (valor, propriedade, indexPosition) => {
        var jaPossuiPrincipal = false;
        if (propriedade === "principal") {
            remuneracao.dadosFinanceiros.map(dados => {
                if (dados.principal && valor === true) {
                    addSnackBar({ message: 'Você ja possui uma conta marcada como princial', info: 'info', open: true });
                    jaPossuiPrincipal = true;;
                }
            })
        }

        if (!jaPossuiPrincipal) {
            remuneracao.dadosFinanceiros[indexPosition][propriedade] = valor;
            remuneracao.dadosFinanceiros[indexPosition].dadosEmpresaSellerId = idSeller;

            changeRemueracaoObj(remuneracao.dadosFinanceiros, "dadosFinanceiros");
        }
    }

    const submitRemuneracao = () => {
        if (!validarForm()) {
            if (!idRemuneracaoSeller) {
                trackPromise(
                    cadastrarRemuneracaoSeller(idSeller, remuneracao)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                            } else {
                                addSnackBar({ message: 'Não foi possível cadastrar remuneração seller', info: 'warning', open: true });
                                /* res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });  
                                }); */

                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao cadastrar remuneração seller', info: 'error', open: true });
                        })
                )
            } else {
                trackPromise(
                    editarRemuneracao(idSeller, remuneracao)
                        .then(res => {
                            if (res.data) {
                                addSnackBar({ message: 'Alterado com sucesso', info: 'success', open: true });
                            } else {
                                addSnackBar({ message: 'Não foi possível alterar remuneração seller', info: 'warning', open: true });
                                /* res.errors.forEach(element => {
                                    addSnackBar({ message: element.menssagem, info: 'warning', open: true });  
                                }); */

                            }
                        }).catch(error => {
                            console.log(error);
                            addSnackBar({ message: 'Erro ao alterar remuneração seller', info: 'error', open: true });
                        })
                )
            }

        }
    }

    const inativarRemuneracao = () => {
        trackPromise(
            inativarRemuneracaoSeller(idRemuneracaoSeller)
                .then(res => {
                    if (res.data) {
                        addSnackBar({ message: 'Inativado com sucesso', info: 'success', open: true });
                    } else {
                        addSnackBar({ message: 'Não foi Inativado remuneração seller', info: 'warning', open: true });
                        /* res.errors.forEach(element => {
                            addSnackBar({ message: element.menssagem, info: 'warning', open: true });  
                        }); */

                    }
                }).catch(error => {
                    console.log(error);
                    addSnackBar({ message: 'Erro ao Inativado remuneração seller', info: 'error', open: true });
                })
        )
    }

    return (
        <div>
            <div className='row mt-1'>
                <span className="col-sm-12 col-md-12 col-lg-12 titulo">Contrato Greeners</span>
                <h1 className='col-sm-12 col-md-12 col-lg-12 sub-titulo'>
                    Status: <strong> { remuneracao.contratoAprovadoSeller
                        ? 'Ativo'
                        : 'Pendente' } </strong>
                </h1>
            </div>

            <div className='row mt20 ml-1'>
                <h1 className='label-second'>Dados do contrato Greeners</h1>
            </div>
            <div className="row mt20">
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <CurrencyTextField
                            fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Fee"
                            size="small"
                            disabled
                            currencySymbol="R$"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            onChange={(event,value) => changeRemueracaoObj(value, 'fee')}
                            value={services.mask.number(remuneracao.fee) || "0"}/>
                    </FormControl>
                </div>
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <CurrencyTextField
                            fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Setup Integração"
                            size="small"
                            disabled
                            currencySymbol="R$"
                            decimalCharacter=","
                            digitGroupSeparator="."
                            onChange={(event, value) => changeRemueracaoObj(value, 'setupIntegracao')}
                            value={services.mask.number(remuneracao.setupIntegracao) || "0"}/>
                    </FormControl>
                </div>
                <div className='col-md-4 col-sm-4 col-lg-4'>
                    <FormControl >
                        <CurrencyTextField 
                            f4ullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Comissão"
                            size="small"
                            disabled
                            currencySymbol="%"
                            decimalCharacter="."
                            onChange={(event, value) => changeRemueracaoObj(value, 'comissao')}
                            value={services.mask.number(remuneracao.comissao) || "0"}/>
                    </FormControl>
                </div>
            </div>


            <div className='row mt20 ml-1'>
                <h1 className='label-second'>Dados Financeiros</h1>
            </div>
            {
                remuneracao.contratoAprovadoSeller
                    ?   remuneracao?.dadosFinanceiros.map((_, index) => (
                            <div key={index}>
                                <PerfilSellerDadosFinanceiros
                                    dadosFinanceiros={remuneracao?.dadosFinanceiros}
                                    indexPosition={index}
                                    setDadosBancarios={contaBancaria}/>
                            </div>
                        ))
                    : 
                    <div className='row'>
                        <span className='col-sm-12 col-md-12 col-lg-12 sub-titulo'>
                            *Contrato pendente de aprovação
                        </span>
                    </div>
            }
            {
                remuneracao.contratoAprovadoSeller
                ?   <div className='row'>
                        <div className='col-md-6 col-lg-6 col-sm-6'>
                            <strong onClick={adicionarConta} className='text-decoration'>+ ADICIONAR CONTA</strong>
                        </div>
                    </div>
                : null
            }



            <div className="col-sm-12 col-md-12 col-lg-12 mt-5 flex flex-end buttons">
                <button className="col-sm-5 col-md-5 col-lg-5 buton-white-black-border" onClick={() => history.push('/home')}>CANCELAR</button>
                {
                    remuneracao.contratoAprovadoSeller
                        ? <button className="col-sm-5 col-md-5 col-lg-5 buton-green" onClick={submitRemuneracao}>SALVAR</button>
                        : null
                }
            </div>
        </div>
    )
}


export default PerfilSellerRemuneracaoGreener;